import React from 'react';
import EngageRequest from '../../../../services/EngageRequest';
import { $state, $stateParams } from '../../../../router';
// Redux 
import GeckoStore from '../../../../services/GeckoStore';
import {
    updateAttendance
} from '../../../../redux/actions';
import AttendanceConstants from '../../../../constants/attendance';
import { 
    GeckoIcon
} from '@geckolabs/gecko-react-ui';
import EventService from '../EventService';

const updateStoreFn = (status) => {
    GeckoStore.redux.dispatch(updateAttendance({status}));    
};

export const AttendanceService = {

    buildRsvpPageUrl: (eventId = null) => {
        return `/#/rsvp/${$stateParams.account_uuid}/${$stateParams.contact_uuid}/${eventId || $stateParams.event_id}`;
    },

    redirectToRsvpPage: (eventId = null, evt = null) => {
        if ((evt || {}).preventDefault) evt.preventDefault();
        return $state.go('rsvp', {
            account_uuid: $stateParams.account_uuid,
            contact_uuid: $stateParams.contact_uuid,
            event_id: eventId || $stateParams.event_id,
            env: $stateParams.env || null
        }, {reload: true});
    },

    renderRsvpPageLink: (str = 'Return to Your RSVP Page', icon = 'arrow-left') => {
        const eventId =EventService.eventId();
        return (
            <a href={AttendanceService.buildRsvpPageUrl(eventId)} onClick={AttendanceService.redirectToRsvpPage.bind(this, eventId)}>
                <GeckoIcon icon={icon} />
                &nbsp;
                {str}
            </a>
        );
    },

    canJoin: (status) => {
        return [AttendanceConstants.STATUS_INVITED, AttendanceConstants.STATUS_REGISTERED].includes(status);
    },

    hasJoined: (status) => {
        return [AttendanceConstants.STATUS_ATTENDED, AttendanceConstants.STATUS_ENGAGED].includes(status);
    },

    cantJoin: (status) => {
        return [
            AttendanceConstants.STATUS_WAITLISTED,
            AttendanceConstants.STATUS_REMOVED,
            AttendanceConstants.STATUS_CANCELLED,
            AttendanceConstants.STATUS_DID_NOT_ATTEND
        ].includes(status);
    },

    checkinFn: () => {
        const endpoint = `/attendances/rsvp/${$stateParams.account_uuid}/${$stateParams.contact_uuid}/${$stateParams.event_id}`;
        const params   = { status: AttendanceConstants.STATUS_ATTENDED };
        return EngageRequest.post(endpoint, params);
    },

    removeFn: (contactUuid, eventId) => {
        const endpoint = `/attendances/rsvp/${$stateParams.account_uuid}/${contactUuid}/${eventId}`;
        const params   = { status: AttendanceConstants.STATUS_REMOVED };
        return EngageRequest.post(endpoint, params);
    },

    attend: () => updateStoreFn(AttendanceConstants.STATUS_ATTENDED)
};

export default AttendanceService;